import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "BalanceMovementsModal" */ /* webpackPrefetch: true */
      './BalanceMovementsModal.component'
    ),
);
